import React from "react";
import ReactDOM from "react-dom/client";
import ProductsList from "./components/products-list";
import Taxonomies from "./components/taxonomies";

const mountPrductsComponent = () => {
  const productsRoot = document.getElementById("products-root");
  if (productsRoot) {
    ReactDOM.createRoot(productsRoot).render(
      <React.StrictMode>
        <ProductsList />
      </React.StrictMode>
    );
  }
};

const mountTaxonomyComponent = () => {
  const taxRoot = document.getElementById("taxonomy-root");
  if (taxRoot) {
    ReactDOM.createRoot(taxRoot).render(
      <React.StrictMode>
        <Taxonomies />
      </React.StrictMode>
    );
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    mountPrductsComponent();
    mountTaxonomyComponent();
  });
} else {
  mountPrductsComponent();
  mountTaxonomyComponent();
}
